/* =============================================================
 * import
 * ========================================================== */
import {mwWpFormError, mwWpFormPrivacyCheck, mwWpFormReCAPTCHA, manageBadgeReCAPTCHA} from "../modules/mwwpform";


/* =============================================================
 * function
 * ========================================================== */
export function setForm() {
  mwWpFormError();
  mwWpFormPrivacyCheck();
  mwWpFormReCAPTCHA();
}

export function resetForm(data) {
  manageBadgeReCAPTCHA(data);
}